import React from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import withStyles from '@material-ui/core/styles/withStyles';

import styles from './main.module.css';
import { palette } from '../../papaya-theme';
import MainMenu from '../menu/menu';
import Routes from '../../routes';
import SharedLinkHeadline from '../shared-link-headline/shared-link-headline';
import { NotificationContainer } from 'react-notifications';

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: `${palette.accent1Color}`,
  },
  barColorPrimary: {
    backgroundColor: `${palette.white}`,
  },
})(LinearProgress);

const isSharedLink = () => window.location.pathname.includes('/decks/shared/');

const Main = ({
  history,
  dispatch,
  user,
  isLoadingRoute,
  isLoadingData,
  isDownloadingFile,
  presentationName,
}) => {
  const renderLoader = () => {
    if (isLoadingRoute || isLoadingData || isDownloadingFile) {
      return <ColorLinearProgress className={styles.loader} />;
    }
  };

  return (
    <div>
      <div className={styles.appMenuSticky}>
        {isSharedLink() && (
          <SharedLinkHeadline presentationName={presentationName} />
        )}
        {!isSharedLink() && (
          <MainMenu user={user.id} isAdmin={user.isAdmin} dispatch={dispatch} />
        )}
        {renderLoader()}
      </div>
      <div>
        <Routes history={history} />
      </div>
      <NotificationContainer />
    </div>
  );
};

const mapStateToProps = state => ({
  isLoadingRoute: state.loader.isLoadingRoute,
  isLoadingData: state.loader.isLoadingData,
  isDownloadingFile: state.loader.isDownloadingFile,
  user: state.user.logged,
  presentationName: state.presentation.name,
});

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/main/main.js